export const BOOKING_TYPES = {
  SINGLE: 'single',
  MULTIPLE: 'multiple'
}

export const SEARCH_TYPES = {
  MEDICAL_SPECIALTIES: 'medical-specialties',
  DIAGNOSTIC_STUDIES: 'diagnostic-studies'
}